<template>
  <weather3
    api-key="2edb1c47047baf170f473486f84c9f33"
    :city="$user.hotel.city"
    :latitude="+$user.hotel.gps.latitude"
    :longitude="+$user.hotel.gps.longitude"
    :language="$i18n.locale"
  />
</template>

<script>
import Weather3 from './Weather3.vue'

export default {
  components: {
    Weather3
  }
}
</script>


<style>
	.vww__widget {
	    width: 100%;
	    min-width: 250px;
	    max-width: inherit !important;
	}
</style>
